<template>
    <li class="stf-nav-item">
        <external-link :href="href">
            <stf-heading-two>{{ text }}</stf-heading-two>
        </external-link>
    </li>
</template>

<script setup lang="ts">
import ExternalLink from '@/components/common/ExternalLink.vue';

defineProps<{
    text: string;
    href: string;
}>();
</script>

<style scoped lang="scss">
@use '@/assets/sass/_variables' as vars;

.stf-nav-item {
  color: vars.$color-white;
  cursor: pointer;

  a {
    color: inherit;
    text-decoration: none;
  }
}
</style>
